var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 41,
    rx: 4,
    fill: "black",
    fillOpacity: 0.73
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5833 19.6821C28.213 20.0456 28.213 20.9544 27.5833 21.3179L17.6667 27.0433C17.037 27.4068 16.25 26.9524 16.25 26.2254L16.25 14.7746C16.25 14.0476 17.037 13.5932 17.6667 13.9567L27.5833 19.6821Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/play-button.895f158020c7c708dcbc0075dc8ab1f3.svg";
export { ForwardRef as ReactComponent };